import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-invoice',
  imports: [RouterModule],
  templateUrl: './admin-invoice.html',
  styleUrl: './admin-invoice.scss',
})
export class AdminInvoice {

}
